import React, { useState } from 'react'
import { Card, CardBody, CardHeader, Col, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from "classnames";
import { VesselTypeConstant } from 'shared/constants';
import { RootState } from 'index';
import { useSelector } from 'react-redux';

const DailyReporting = () => {
    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const { VesselID, Vessels } = useSelector((state: RootState) => state.Reporting);
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);

    const toggleVertical = (tab: any) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };
    return (
        <>
            <Row className='mt-3'>
                <Col lg={11}>
                    <h5 className="modal-title ml-1_25" id="staticBackdropLabel">
                        Select fields to be included in the report
                    </h5>
                </Col>
                <Col lg={1} className='nopadleft'>
                    <strong className='mb-0'>Select all</strong>
                    <div className="square-switch sqswitch">
                        <Input
                            type="checkbox"
                            switch="none"
                            name='all_fields'
                            id='all_fields'
                        />
                        <Label
                            htmlFor='all_fields'
                            data-on-label='Yes'
                            data-off-label='No'>
                        </Label>
                    </div>
                </Col>
            </Row>
            <CardBody className='nopadtop'>
                <Row>
                    <Col md="3">
                        <Nav pills className="flex-column">
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '1',
                                    })}
                                    onClick={() => {
                                        toggleVertical('1');
                                    }}
                                >
                                    Weather Data
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '3',
                                    })}
                                    onClick={() => {
                                        toggleVertical('3');
                                    }}
                                >
                                    CP Warranties
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '4',
                                    })}
                                    onClick={() => {
                                        toggleVertical('4');
                                    }}
                                >
                                    Drafts & Displacement
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '5',
                                    })}
                                    onClick={() => {
                                        toggleVertical('5');
                                    }}
                                >
                                    Ballast Details & Operations
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '6',
                                    })}
                                    onClick={() => {
                                        toggleVertical('6');
                                    }}
                                >
                                    Cargo Details
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '7',
                                    })}
                                    onClick={() => {
                                        toggleVertical('7');
                                    }}
                                >
                                    Bill of Lading
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '8',
                                    })}
                                    onClick={() => {
                                        toggleVertical('8');
                                    }}
                                >
                                    ETA/ETD
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '9',
                                    })}
                                    onClick={() => {
                                        toggleVertical('9');
                                    }}
                                >
                                    Voyage Parameters
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '10',
                                    })}
                                    onClick={() => {
                                        toggleVertical('10');
                                    }}
                                >
                                    Shore Supply
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '11',
                                    })}
                                    onClick={() => {
                                        toggleVertical('11');
                                    }}
                                >
                                    Fuel Consumption
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '12',
                                    })}
                                    onClick={() => {
                                        toggleVertical('12');
                                    }}
                                >
                                    Energy Paramters
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '13',
                                    })}
                                    onClick={() => {
                                        toggleVertical('13');
                                    }}
                                >
                                    Machinery Running Hours
                                </NavLink>
                            </NavItem>
                            {vessel && vessel?.vessel_type === VesselTypeConstant.TANKER &&
                                <>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                "mb-2": true,
                                                active: verticalActiveTab === '14',
                                            })}
                                            onClick={() => {
                                                toggleVertical('14');
                                            }}
                                        >
                                            Cargo Heating
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                "mb-2": true,
                                                active: verticalActiveTab === '15',
                                            })}
                                            onClick={() => {
                                                toggleVertical('15');
                                            }}
                                        >
                                            Cargo Discharging
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                "mb-2": true,
                                                active: verticalActiveTab === '16',
                                            })}
                                            onClick={() => {
                                                toggleVertical('16');
                                            }}
                                        >
                                            Tank Cleaning
                                        </NavLink>
                                    </NavItem>
                                </>
                            }
                            {vessel && vessel?.vessel_type === VesselTypeConstant.CONTAINER &&
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === '17',
                                        })}
                                        onClick={() => {
                                            toggleVertical('17');
                                        }}
                                    >
                                        Reefer Conatiner
                                    </NavLink>
                                </NavItem>
                            }
                            {vessel && (vessel?.vessel_type === VesselTypeConstant.GAS_CARRIER ||
                                vessel?.vessel_type === VesselTypeConstant.LNG_CARRIER) &&
                                <>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                "mb-2": true,
                                                active: verticalActiveTab === '18',
                                            })}
                                            onClick={() => {
                                                toggleVertical('18');
                                            }}
                                        >
                                            Cargo Cooling
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                "mb-2": true,
                                                active: verticalActiveTab === '19',
                                            })}
                                            onClick={() => {
                                                toggleVertical('19');
                                            }}
                                        >
                                            Cargo Reliquification
                                        </NavLink>
                                    </NavItem>
                                </>
                            }
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '20',
                                    })}
                                    onClick={() => {
                                        toggleVertical('20');
                                    }}
                                >
                                    Other Special Operation
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '21',
                                    })}
                                    onClick={() => {
                                        toggleVertical('21');
                                    }}
                                >
                                    Bunkering
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '22',
                                    })}
                                    onClick={() => {
                                        toggleVertical('22');
                                    }}
                                >
                                    Fuel Debunkering
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '23',
                                    })}
                                    onClick={() => {
                                        toggleVertical('23');
                                    }}
                                >
                                    Lube Oil Bunkering
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '24',
                                    })}
                                    onClick={() => {
                                        toggleVertical('24');
                                    }}
                                >
                                    Lube Oil Debunkering
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '25',
                                    })}
                                    onClick={() => {
                                        toggleVertical('25');
                                    }}
                                >
                                    Fresh Water
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                        "mb-2": true,
                                        active: verticalActiveTab === '26',
                                    })}
                                    onClick={() => {
                                        toggleVertical('26');
                                    }}
                                >
                                    Lube Oil ROB
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Col>
                    <Col md="9">
                        <TabContent
                            activeTab={verticalActiveTab}
                            className="text-muted mt-4 mt-md-0"
                        >
                            <TabPane tabId='1'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='weather_data'
                                                name='weather_data'
                                            />
                                            <h5 className='ms-2'>Weather Data</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='steaming_time'
                                                    name='steaming_time'
                                                />
                                                <Label className='font-12 ms-1'>Steaming time</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='distance_travelled'
                                                    name='distance_travelled'
                                                />
                                                <Label className='font-12 ms-1'>Distance travelled</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='avg_ground_speed'
                                                    name='avg_ground_speed'
                                                />
                                                <Label className='font-12 ms-1'>Avg. ground speed</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='avg_water_speed'
                                                    name='avg_water_speed'
                                                />
                                                <Label className='font-12 ms-1'>Avg. water speed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='wind_direction'
                                                    name='wind_direction'
                                                />
                                                <Label className='font-12 ms-1'>Wind direction</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='wind_speed'
                                                    name='wind_speed'
                                                />
                                                <Label className='font-12 ms-1'>Wind speed</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='beaufort_scale'
                                                    name='beaufort_scale'
                                                />
                                                <Label className='font-12 ms-1'>Beaufort scale</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='swell_direction'
                                                    name='swell_direction'
                                                />
                                                <Label className='font-12 ms-1'>Swell direction</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='swell_height'
                                                    name='swell_height'
                                                />
                                                <Label className='font-12 ms-1'>Swell height</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ocean_current_speed'
                                                    name='ocean_current_speed'
                                                />
                                                <Label className='font-12 ms-1'>Ocean current's speed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ocean_wave_height'
                                                    name='ocean_wave_height'
                                                />
                                                <Label className='font-12 ms-1'>Ocean wave height</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='sea_force'
                                                    name='sea_force'
                                                />
                                                <Label className='font-12 ms-1'>Sea force</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ocean_current_direction'
                                                    name='ocean_current_direction'
                                                />
                                                <Label className='font-12 ms-1'>Ocean current's direction</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='period_in_bad_weather'
                                                    name='period_in_bad_weather'
                                                />
                                                <Label className='font-12 ms-1'>Period in bad weather</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='air_temperature'
                                                    name='air_temperature'
                                                />
                                                <Label className='font-12 ms-1'>Air temperature</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='sea_temperature'
                                                    name='sea_temperature'
                                                />
                                                <Label className='font-12 ms-1'>Sea temperature</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='gyro_course'
                                                    name='gyro_course'
                                                />
                                                <Label className='font-12 ms-1'>Gyro course</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='barometric_pressure'
                                                    name='barometric_pressure'
                                                />
                                                <Label className='font-12 ms-1'>Barometric pressure</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='3'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='cp_warranties'
                                                name='cp_warranties'
                                            />
                                            <h5 className='ms-2'>CP Warranties</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ordered_speed'
                                                    name='ordered_speed'
                                                />
                                                <Label className='font-12 ms-1'>Ordered speed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ordered_fuel_oil_consumption'
                                                    name='ordered_fuel_oil_consumption'
                                                />
                                                <Label className='font-12 ms-1'>Ordered fuel</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId="4">
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='drafts_displacement'
                                                name='drafts_displacement'
                                            />
                                            <h5 className='ms-2'>Drafts & Displacement</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='fwd_draft'
                                                    name='fwd_draft'
                                                />
                                                <Label className='font-12 ms-1'>Fwd draft</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='draft_mid'
                                                    name='draft_mid'
                                                />
                                                <Label className='font-12 ms-1'>Mid draft</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='draft_aft'
                                                    name='draft_aft'
                                                />
                                                <Label className='font-12 ms-1'>Aft draft</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='trim'
                                                    name='trim'
                                                />
                                                <Label className='font-12 ms-1'>Trim</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='displacement'
                                                    name='displacement'
                                                />
                                                <Label className='font-12 ms-1'>Displacement</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId="5">
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='ballast_details_operations'
                                                name='ballast_details_operations'
                                            />
                                            <h5 className='ms-2'>Ballast Details & Operations</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='permanent'
                                                    name='permanent'
                                                />
                                                <Label className='font-12 ms-1'>Permanent ballast</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='addition'
                                                    name='addition'
                                                />
                                                <Label className='font-12 ms-1'>Additional ballast</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='total'
                                                    name='total'
                                                />
                                                <Label className='font-12 ms-1'>Total ballast</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='loaded'
                                                    name='loaded'
                                                />
                                                <Label className='font-12 ms-1'>Loaded</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='discharged'
                                                    name='discharged'
                                                />
                                                <Label className='font-12 ms-1'>Discharged</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='6'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='cargo_details'
                                                name='cargo_details'
                                            />
                                            <h5 className='ms-2'>Cargo Details</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='cargo_detail'
                                                    name='cargo_detail'
                                                />
                                                <Label className='font-12 ms-1'>Cargo details</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_cargo_loaded'
                                                    name='amount_of_cargo_loaded'
                                                />
                                                <Label className='font-12 ms-1'>Amount of cargo loaded</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_cargo_discharged'
                                                    name='amount_of_cargo_discharged'
                                                />
                                                <Label className='font-12 ms-1'>Amount of cargo discharged</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mn-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='total_amount_of_cargo_onboard'
                                                    name='total_amount_of_cargo_onboard'
                                                />
                                                <Label className='font-12 ms-1'>Total cargo onboard</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='7'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='machinery_running'
                                                name='machinery_running'
                                            />
                                            <h5 className='ms-2'>Bill of Lading</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='bl_figure'
                                                    name='bl_figure'
                                                />
                                                <Label className='font-12 ms-1'>BL figures(Cargo)</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='ship_figure_of_bl_figure'
                                                    name='ship_figure_of_bl_figure'
                                                />
                                                <Label className='font-12 ms-1'>Ship figures(Cargo)</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='surveyor_figure_of_bl_figure'
                                                    name='surveyor_figure_of_bl_figure'
                                                />
                                                <Label className='font-12 ms-1'>Surveyor figures(Cargo)</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='8'>

                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='etad'
                                                name='etad'
                                            />
                                            <h5 className='ms-2'>Expected Time of Arrival/Departure</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='arrival_port_name'
                                                    name='arrival_port_name'
                                                />
                                                <Label className='font-12 ms-1'>Arrival port name</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='masters_eta_at_pilot_station'
                                                    name='masters_eta_at_pilot_station'
                                                />
                                                <Label className='font-12 ms-1'>Master's ETA at pilot station</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='expected_time_of_arrival_at_eca'
                                                    name='expected_time_of_arrival_at_eca'
                                                />
                                                <Label className='font-12 ms-1'>Expected time of arrival at ECA</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='departure_port_name'
                                                    name='departure_port_name'
                                                />
                                                <Label className='font-12 ms-1'>Departure port name</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='master_etd_from_present_port'
                                                    name='master_etd_from_present_port'
                                                />
                                                <Label className='font-12 ms-1'>Master's ETD from present port</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='expected_time_of_depature_from_eca'
                                                    name='expected_time_of_depature_from_eca'
                                                />
                                                <Label className='font-12 ms-1'>Expected time of departure from ECA</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mn-2'>
                                            <Col lg={4}>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='date_and_time_of_arrival_at_eca'
                                                        name='date_and_time_of_arrival_at_eca'
                                                    />
                                                    <Label className='font-12 ms-1'>Date & time of arrival at ECA<br /> if vessel will transit ECA region</Label>
                                                </div>
                                            </Col>
                                            <Col lg={4}>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='date_and_time_of_departure_from_eca'
                                                        name='date_and_time_of_departure_from_eca'
                                                    />
                                                    <Label className='font-12 ms-1'>Date & time of departure from ECA<br /> if vessel will transit ECA region</Label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='9'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='voyage_parameter'
                                                name='voyage_parameter'
                                            />
                                            <h5 className='ms-2'>Voyage Parameters</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='set_rpm'
                                                    name='set_rpm'
                                                />
                                                <Label className='font-12 ms-1'>Set propeller RPM</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='avg_rpm'
                                                    name='avg_rpm'
                                                />
                                                <Label className='font-12 ms-1'>Average propeller RPM</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='total_revolutions'
                                                    name='total_revolutions'
                                                />
                                                <Label className='font-12 ms-1'>Total revolutions</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='slip_percentage'
                                                    name='slip_percentage'
                                                />
                                                <Label className='font-12 ms-1'>Slip %</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='10'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='shore_supply'
                                                name='shore_supply'
                                            />
                                            <h5 className='ms-2'>Shore Supply</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='is_shore_supply_available'
                                                    name='is_shore_supply_available'
                                                />
                                                <Label className='font-12 ms-1'>Shore supply available</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='is_shore_supply_used'
                                                    name='is_shore_supply_used'
                                                />
                                                <Label className='font-12 ms-1'>Shore supply used</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='time_on_shore_supply'
                                                    name='time_on_shore_supply'
                                                />
                                                <Label className='font-12 ms-1'>Time on shore supply</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='quantity_of_shore_supply'
                                                    name='quantity_of_shore_supply'
                                                />
                                                <Label className='font-12 ms-1'>Quantity of shore supply used</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='11'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='fuel_consumption'
                                                name='fuel_consumption'
                                            />
                                            <h5 className='ms-2'>Fuel Consumption</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='method_used_to_measure_fuel_oil_consumption'
                                                        name='method_used_to_measure_fuel_oil_consumption'
                                                    />
                                                    <Label className='font-12 ms-1'>Method used to measure fuel consumption</Label>
                                                </div>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='fuel_consumed'
                                                    name='fuel_consumed'
                                                />
                                                <Label className='font-12 ms-1'>Fuel consumed</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='12'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='energy_parameter'
                                                name='energy_parameter'
                                            />
                                            <h5 className='ms-2'>Energy Parameters</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='energy_developed'
                                                    name='energy_developed'
                                                />
                                                <Label className='font-12 ms-1'>Energy developed/consumed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='running_hours'
                                                    name='running_hours'
                                                />
                                                <Label className='font-12 ms-1'>Running hours</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='avg_power'
                                                    name='avg_power'
                                                />
                                                <Label className='font-12 ms-1'>Average power</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='13'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='machinery_running_hrs'
                                                name='machinery_running_hrs'
                                            />
                                            <h5 className='ms-2'>Machinery Running Hours</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='running_hours'
                                                    name='running_hours'
                                                />
                                                <Label className='font-12 ms-1'>Running hours</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            {vessel && vessel?.vessel_type === VesselTypeConstant.TANKER &&
                                <>
                                    <TabPane tabId='14'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='cargo_heating'
                                                        name='cargo_heating'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Cargo Heating</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                    <TabPane tabId='15'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='cargo_discharging'
                                                        name='cargo_discharging'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Cargo Discharging</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                    <TabPane tabId='16'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='tank_cleaning'
                                                        name='tank_cleaning'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Cargo Discharging</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                </>
                            }
                            {vessel && vessel?.vessel_type === VesselTypeConstant.CONTAINER &&
                                <>
                                    <TabPane tabId='17'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='reefer_container'
                                                        name='reefer_conatiner'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Reefer Container</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                </>
                            }
                            {vessel && (vessel?.vessel_type === VesselTypeConstant.LNG_CARRIER || vessel?.vessel_type === VesselTypeConstant.GAS_CARRIER) &&
                                <>
                                    <TabPane tabId='18'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='cargo_cooling'
                                                        name='cargo_cooling'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Cargo Cooling</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                    <TabPane tabId='19'>
                                        <Card>
                                            <CardHeader>
                                                <div className='ele_row1'>
                                                    <Input
                                                        type='checkbox'
                                                        id='cargo_reliquification'
                                                        name='cargo_reliquification'
                                                    />
                                                    <h5 className='ms-2'>Special Operations - Cargo Reliquification</h5>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <Row className='mb-2'>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='fuel_consumption_value'
                                                            name='fuel_consumption_value'
                                                        />
                                                        <Label className='font-12 ms-1'>Fuel consumed</Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            type='checkbox'
                                                            id='energy_consumed'
                                                            name='energy_consumed'
                                                        />
                                                        <Label className='font-12 ms-1'>Energy consumed</Label>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </TabPane>
                                </>
                            }
                            <TabPane tabId='20'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='other_operation'
                                                name='other_operation'
                                            />
                                            <h5 className='ms-2'>Other Special Operation</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='fuel_consumption_value'
                                                    name='fuel_consumption_value'
                                                />
                                                <Label className='font-12 ms-1'>Fuel consumed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='energy_consumption_value'
                                                    name='energy_consumption_value'
                                                />
                                                <Label className='font-12 ms-1'>Energy consumed</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='21'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='bunkering'
                                                name='bunkering'
                                            />
                                            <h5 className='ms-2'>Bunkering</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='vessel_fuelname'
                                                    name='vessel_fuelname'
                                                />
                                                <Label className='font-12 ms-1'>Fuel</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='quantity_bunkered'
                                                    name='quantity_bunkered'
                                                />
                                                <Label className='font-12 ms-1'>Quantity bunkered</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='density'
                                                    name='density'
                                                />
                                                <Label className='font-12 ms-1'>Density</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='viscosity'
                                                    name='viscosity'
                                                />
                                                <Label className='font-12 ms-1'>Viscosity</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='sulphur_percentage'
                                                    name='sulphur_percentage'
                                                />
                                                <Label className='font-12 ms-1'>Sulphur percentage</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='port_of_bunkering'
                                                    name='port_of_bunkering'
                                                />
                                                <Label className='font-12 ms-1'>Port of bunkering</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='date_of_bunkering'
                                                    name='date_of_bunkering'
                                                />
                                                <Label className='font-12 ms-1'>Date of bunkering</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='22'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='debunkering'
                                                name='debunkering'
                                            />
                                            <h5 className='ms-2'>Fuel Deunkering</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='fuel_type_name'
                                                    name='fuel_type_name'
                                                />
                                                <Label className='font-12 ms-1'>Fuel</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='quantity_debunkered'
                                                    name='quantity_debunkered'
                                                />
                                                <Label className='font-12 ms-1'>Quantity debunkered</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='port_of_debunkering'
                                                    name='port_of_debunkering'
                                                />
                                                <Label className='font-12 ms-1'>Port of debunkering</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='date_of_debunkering'
                                                    name='date_of_debunkering'
                                                />
                                                <Label className='font-12 ms-1'>Date of debunkering</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='23'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='lo_bunkering'
                                                name='lo_bunkering'
                                            />
                                            <h5 className='ms-2'>Lube Oil Bunkering</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='vessel_lube_oil_name'
                                                    name='vessel_lube_oil_name'
                                                />
                                                <Label className='font-12 ms-1'>Lube oil</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='quantity_bunkered'
                                                    name='quantity_bunkered'
                                                />
                                                <Label className='font-12 ms-1'>Quantity bunkered</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='port_of_bunkering_name'
                                                    name='port_of_bunkering_name'
                                                />
                                                <Label className='font-12 ms-1'>Port of bunkering</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='date_of_bunkering'
                                                    name='date_of_bunkering'
                                                />
                                                <Label className='font-12 ms-1'>Date of bunkering</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='24'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='lo_debunkering'
                                                name='lo_debunkering'
                                            />
                                            <h5 className='ms-2'>Lube Oil Debunkering</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='lube_oil'
                                                    name='lube_oil'
                                                />
                                                <Label className='font-12 ms-1'>Lube oil</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='quantity_debunkered'
                                                    name='quantity_debunkered'
                                                />
                                                <Label className='font-12 ms-1'>Quantity debunkered</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='port_of_debunkering'
                                                    name='port_of_debunkering'
                                                />
                                                <Label className='font-12 ms-1'>Port of debunkering</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='date_of_debunkering'
                                                    name='date_of_debunkering'
                                                />
                                                <Label className='font-12 ms-1'>Date of debunkering</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='25'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='fresh_water'
                                                name='fresh_water'
                                            />
                                            <h5 className='ms-2'>Fresh Water</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_fresh_water_produced'
                                                    name='amount_of_fresh_water_produced'
                                                />
                                                <Label className='font-12 ms-1'>Amount of fresh water produced</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_fresh_water_received'
                                                    name='amount_of_fresh_water_received'
                                                />
                                                <Label className='font-12 ms-1'>Amount of fresh water recieved</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_domestic_water_consumed'
                                                    name='amount_of_domestic_water_consumed'
                                                />
                                                <Label className='font-12 ms-1'>Amount of domestic water consumed</Label>
                                            </Col>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='amount_of_distilled_water_consumed'
                                                    name='amount_of_distilled_water_consumed'
                                                />
                                                <Label className='font-12 ms-1'>Amount of distilled water consumed</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='rob'
                                                    name='rob'
                                                />
                                                <Label className='font-12 ms-1'>Fresh water ROB</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId='26'>
                                <Card>
                                    <CardHeader>
                                        <div className='ele_row1'>
                                            <Input
                                                type='checkbox'
                                                id='lo_rob'
                                                name='lo_rob'
                                            />
                                            <h5 className='ms-2'>Lube Oil ROB</h5>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className='mb-2'>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='lube_oil_name'
                                                    name='lube_oil_name'
                                                />
                                                <Label className='font-12 ms-1'>Lube oil</Label>
                                            </Col>
                                            <Col lg={4}>
                                                <Input
                                                    type='checkbox'
                                                    id='lrob'
                                                    name='lrob'
                                                />
                                                <Label className='font-12 ms-1'>ROB</Label>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </CardBody>
        </>
    )
}

export default DailyReporting